module.exports = __webpack_public_path__ + "img/tmall.d5faffee.png";